<template>
    <div>
        <div class="content-header row">
            <div class="content-header-left col-md-6 col-12 mb-2">
                <h3 class="content-header-title mb-0">Drivers</h3>
                <div class="row breadcrumbs-top">
                    <div class="breadcrumb-wrapper col-12">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="/">Home</a>
                            </li>
                            <li class="breadcrumb-item active">Deleted Drivers
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>

        <div class="content-body">
            <section class="card">
                <div class="card-header">
                    <h4>Deleted Drivers</h4>
                </div>

                <div class="card-body">
                    <div class="row mb-2">
                        <div class="form-group col-md-4">
                            <input type="text" v-model="searchTerm"
                                class="form-control"
                                placeholder="🔎 Search this table (Name, email, phone)"
                                @keyup="paginatedData"
                            >
                        </div>
                    </div>

                    <vue-good-table
                        class="dataTable"
                        mode="remote"
                        :isLoading.sync="tableDataLoading"
                        :totalRows="totalRecords"
                        :pagination-options="paginationOptions"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        styleClass="vgt-table"
                        :columns="columns"
                        :rows="allDrivers"
                    >

                        <div slot="emptystate" class="loading-container">
                            <img src="/images/Spinner.svg" alt="">
                        </div>
                        <template slot="table-row" slot-scope="props">
                             <span v-if="props.column.field === 'sn'">
                                    {{ serialNo(props) }}
                             </span>
                            <span v-else-if="props.column.field === 'email'">
                                <a :href="`mailto:${props.row.email}`">{{ props.row.email }}</a>
                            </span>
                            <span v-else-if="props.column.label === 'Name'">
<!--                               <a :href="route('admin.drivers.show', props.row.id)">{{-->
                                <!--                                       props.row.first_name + ' ' + props.row.last_name-->
                                <!--                                   }}</a>-->
                                {{
                                    props.row.first_name + ' ' + props.row.last_name
                                }}
                            </span>

                            <span v-else-if="props.column.label === 'Status'" class="badge badge-danger">
                                deleted
                            </span>
                            <span v-else-if="props.column.field === 'created_at'">
                                {{ formatDateTime(props.row.created_at) }}
                            </span>
                            <span v-else-if="props.column.field === 'deleted_at'">
                                {{ formatDateTime(props.row.deleted_at) }}
                            </span>
                            <span v-else-if="props.column.field === 'action'">
                                <span class="dropdown">
									<a id="btnSearchDrop2" data-toggle="dropdown" aria-haspopup="true"
                                       aria-expanded="false" class="dropdown-toggle dropdown-menu-right"><i
                                        class="fa fa-ellipsis-v"></i></a>
                                    <span aria-labelledby="btnSearchDrop2"
                                          class="dropdown-menu mt-1 dropdown-menu-right"
                                          x-placement="bottom-end"
                                          style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 19px, 0px);"
                                          x-out-of-boundaries="">
                                        <a href="#"
                                           @click.prevent="restoreAccount(props.row.id)" class="dropdown-item">
                                              <i class="feather icon-check"></i>
                                                Restore Account
                                        </a>
                                        <a href="#" @click.prevent="showAlert(props.row.id)" class="dropdown-item text-danger delete">
                                            <i class="feather icon-trash-2"></i>
                                            Permanently Delete
                                        </a>
                                    </span>
                                </span>
                            </span>
                        </template>
                    </vue-good-table>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import Layout from '@/Shared/Layout';

export default {
    metaInfo: {title: 'Driver'},
    props: ['drivers'],
    name: "DriverIndex",
    layout: Layout,

    data: () => ({
        filter: {},
        isLoadingFilter: false,
        allDrivers: [],
        searchDriver:{},
        totalRecords: 0,
        serverParams: {
            page: 1,
            perPage: 10
        },
        paginationOptions: {
            enabled: true,
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [5, 10, 20, 50, 100, 200],
            dropdownAllowAll: false,
        },
        columns: [
            {label: 'S/N', field: 'sn'},
            {label: 'Name', field: 'name'},
            {label: 'Email', field: 'email'},
            {label: 'Phone', field: 'phone_number'},
            {label: 'Date Joined', field: 'created_at'},
            {label: 'Deleted at', field: 'deleted_at'},
            {label: 'Status', field: 'status'},
            {label: 'Action', field: 'action', sortable: false},
        ],
        tableDataLoading: false,
        searchTerm: '',
    }),
    created() {
        this.allDrivers = this.drivers.data
        this.totalRecords = this.drivers.total
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
        },
        onPageChange(params) {
            this.updateParams({page: params.currentPage});
            this.paginatedData();
        },
        onPerPageChange(params) {
            this.updateParams({perPage: params.currentPerPage});
            this.paginatedData();
        },
        onSortChange(params) {
            this.serverParams.sort = {
                type: params[0].type,
                field: params[0].field,
            }
            this.paginatedData();
        },
        async paginatedData() {
            try {
                let url = route('admin.drivers.deleted') +
                    `?q=${this.searchTerm}&page=${this.serverParams.page}&perPage=${this.serverParams.perPage}`;
                let {data: {data: {drivers}}} = await axios.get(url);

                this.totalRecords = drivers.total;
                this.paginationOptions.perPage = drivers.per_page;
                this.allDrivers = drivers.data
            } catch (e) {
                console.log(e);
            }
        },

        restoreAccount(driverId) {
            try {
                let routeName = 'admin.drivers.restore';

                this.$inertia.post(route(routeName, driverId), {}, {
                    preserveScroll: true,
                    onSuccess: (response) => {
                        // const driverIndex = this.allDrivers.findIndex(a => driverId === a.id);
                        // this.allDrivers[driverIndex].is_active = this.allDrivers[driverIndex].is_active === 1 ? 0 : 1;

                        if (! response.props.flash.error) {
                            this.paginatedData();
                        }
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },

        deleteAccount(driverId) {
            try {
                let routeName = 'admin.drivers.delete';

                this.$inertia.post(route(routeName, driverId), {
                    '_method' : 'delete'
                }, {
                    preserveScroll: true,
                    onSuccess: (response) => {
                        if (! response.props.flash.error) {
                            this.paginatedData();
                        }
                    },
                });
            } catch (e) {
                console.log(e);
                this.saving = false
            }
        },

        showAlert(accountId) {
            let vInstance = this;

            this.$swal.fire({
                title: "Are you sure you want to delete this Driver permanently?",
                text: "You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!",
                confirmButtonClass: "btn btn-primary mr-3",
                cancelButtonClass: "btn btn-danger ml-1",
                buttonsStyling: false
            }).then(function (result) {
                if (result.value) {
                    vInstance.deleteAccount(accountId)
                }
            });
        },

        serialNo(props) {
            return this.serverParams.page === 1 ? props.index + 1 : (this.serverParams.perPage *
                    (this.serverParams.page - 1)) +
                props.index + 1
        },

        formatDateTime(value) {
            if (! value) return value

            const date = new Date(value);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
    }
}
</script>
